import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import styles from './NetworkError.module.scss';
import { IoCloudOfflineOutline, IoRefresh, IoWifiOutline, IoWarningOutline } from 'react-icons/io5';

// --- 1. CONTEXT QUẢN LÝ MẠNG ---
const NetworkContext = createContext();

export const NetworkProvider = ({ children }) => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [isTimeout, setIsTimeout] = useState(false);

  // Hàm reload trang
  const handleRetry = () => {
    setIsOffline(false);
    setIsTimeout(false);
    window.location.reload();
  };

  useEffect(() => {
    // 1. Lắng nghe sự kiện Online/Offline của trình duyệt
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // 2. Cấu hình Axios toàn cục
    // Thời gian chờ tối đa: 15 giây (15000ms). Nếu quá sẽ báo lỗi.
    axios.defaults.timeout = 15000; 

    // Interceptor: "Cảnh sát" chặn mọi phản hồi từ API
    const interceptor = axios.interceptors.response.use(
      (response) => response, // Nếu thành công thì cho qua
      (error) => {
        // Nếu lỗi do mất mạng
        if (error.message === 'Network Error' || !navigator.onLine) {
          setIsOffline(true);
        }
        // Nếu lỗi do Timeout (quá lâu)
        else if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
          setIsTimeout(true);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  // Nếu bị lỗi mạng hoặc timeout -> Hiển thị màn hình lỗi ngay lập tức
  if (isOffline || isTimeout) {
    return (
      <div className={styles.errorPageWrapper}>
        <div className={styles.errorContent}>
          <div className={styles.iconWrapper}>
            {isOffline ? <IoCloudOfflineOutline /> : <IoWarningOutline />}
          </div>
          
          <h2 className={styles.errorTitle}>
            {isOffline ? 'Mất Kết Nối Internet' : 'Phản Hồi Quá Lâu'}
          </h2>
          
          <p className={styles.errorMessage}>
            {isOffline 
              ? 'Vui lòng kiểm tra lại đường truyền mạng của bạn và thử lại.' 
              : 'Hệ thống đang phản hồi chậm hơn dự kiến. Vui lòng tải lại trang.'}
          </p>

          <button onClick={handleRetry} className={styles.retryButton}>
            <IoRefresh className={styles.spinIcon} /> Thử Lại Ngay
          </button>

          <div className={styles.checkSteps}>
            <p>Hãy thử:</p>
            <ul>
              <li><IoWifiOutline /> Kiểm tra modem wifi hoặc 4G</li>
              <li>Đợi vài giây rồi tải lại</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  // Nếu bình thường -> Hiển thị Web
  return (
    <NetworkContext.Provider value={{ isOffline, isTimeout }}>
      {children}
    </NetworkContext.Provider>
  );
};